
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getAlarmOrderDetail } from "@/api/api-basic";
@Component
export default class AllarmQueryDetail extends Vue {
  private modalShow = false;
  private getLoading = false;
  private loading = true;
  private FormData: objAny = {};
  private modalTitle = "告警详情";
  private ruleInline: objAny = {};
  private formItem: objAny = {
    orderNumber: "",
    orderTime: "",
    chargeElectricity: "",
    electricityCharge: "",
    serviceCharge: "",
    totalCharge: "",

    chargePileElectricity: {
      beginTime: "",
      endTime: "",
      totalPrice: "",
      errorPercent: "",
      normal: "",
      typeList: [
        //     {
        // 	type: "",
        // 	electricity: "",
        // 	electricityFee: "",
        // 	serviceFee: "",
        // 	totalPirce: ""
        // }
      ]
    },
    platformElectricity: {
      beginTime: "",
      endTime: "",
      totalPrice: "",
      errorPercent: "",
      normal: "",
      typeList: [
        //     {
        // 	type: "",
        // 	electricity: "",
        // 	electricityFee: "",
        // 	serviceFee: "",
        // 	totalPirce: ""
        // }
      ]
    }
  };
  private tableListFirst: object[] = [];
  private tableColumnsFirst: object[] = [
    // {
    //   title: "序号",
    //   key: "index",
    //   resizable: true,
    //   minWidth: 60,
    //   slot: "index"
    // },
    {
      title: "电价类型",
      key: "type",
      resizable: true,
      minWidth: 100
    },
    {
      title: "电量(kWh)",
      key: "electricity",
      resizable: true,
      minWidth: 130
    },
    {
      title: "电费费率(元/kWh)",
      key: "electricityFee",
      resizable: true,
      minWidth: 130
    },
    {
      title: "服务费费率(元/kWh)",
      key: "serviceFee",
      resizable: true,
      minWidth: 140
    },
    {
      title: "总价(元)",
      key: "totalPirce",
      resizable: true,
      minWidth: 100
    }
  ];
  private tableListSecond: object[] = [];
  private tableColumnsSecond: object[] = [
    // {
    //   title: "序号",
    //   key: "index",
    //   resizable: true,
    //   minWidth: 60,
    //   slot: "index"
    // },
    {
      title: "电价类型",
      key: "type",
      resizable: true,
      minWidth: 130
    },
    {
      title: "电量(kWh)",
      key: "electricity",
      resizable: true,
      minWidth: 130
    },
    {
      title: "电费费率(元/kWh)",
      key: "electricityFee",
      resizable: true,
      minWidth: 130
    },
    {
      title: "服务费费率(元/kWh)",
      key: "serviceFee",
      resizable: true,
      minWidth: 90
    },
    {
      title: "总价(元",
      key: "totalPirce",
      resizable: true,
      minWidth: 120
    }
  ];
  public open(item: objAny) {
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
      });
    } else {
      this.handleReset();
    }
    this.modalShow = true;
    this.getAlarmOrderDetail(item.objectId);
  }

  public handleSubmit(): void {
    this.loading = true;

    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      } else {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      }
    });
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  async submitData(): Promise<void> {
    // let ret: objAny;
    this.loading = false;
  }
  async getAlarmOrderDetail(val: string): Promise<void> {
    const ret = await getAlarmOrderDetail({ objectId: val });
    if (ret.status === this.$config.apiStatus) {
      if (ret.data.length > 0) {
        this.formItem = ret.data[0];
        this.tableListFirst = ret.data[0].chargePileElectricity.typeList;
        this.tableListSecond = ret.data[0].platformElectricity.typeList;
      }
    }
  }
  mounted() {
    this.$emit("getChild", this);
  }
}
